import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88c21080&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=88c21080&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c21080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c21080')) {
      api.createRecord('88c21080', component.options)
    } else {
      api.reload('88c21080', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=88c21080&scoped=true", function () {
      api.rerender('88c21080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/optimization/index.vue"
export default component.exports